import {IsString, ToJSON_Advanced} from "js-vextensions";
import {LogTypes} from "web-vcore_UserTypes";
import {SessionLog} from "../../UI/Tools/@Shared/BetweenSessionTypes/SessionLog.js";
import {LogType} from "../../UI/Tools/@Shared/LogEntry.js";
import {OnFirstSessionStart} from "./GlobalHooks.js";
import * as THREE from "three";

export class LogTypes_New {
	//actions = false;
	nodeRenders = false;
	nodeRenders_for = null as string|n;
	nodeRenderDetails = false;
	nodeRenderDetails_for = null as string|n;

	// doesn't actually log; rather, causes data to be stored in component.props.extraInfo.renderTriggers
	renderTriggers = false;
}

export const logTypes = new LogTypes_New() as LogTypes;
G({logTypes}); // expose logTypes globally for console-editing, but don't mention to TS

if (localStorage.getItem("logTypes")) {
	logTypes.Extend(JSON.parse(localStorage.getItem("logTypes")!));
}
g.addEventListener("beforeunload", ()=>{
	localStorage.setItem("logTypes", JSON.stringify(logTypes));
});

// console intercept functions
// ==========

const capturePreSessionLogs_StorageKey = "capturePreSessionLogs";
export function GetCapturePreSessionLogs() {
	const stored = localStorage.getItem(capturePreSessionLogs_StorageKey);
	// default to false, when no value stored yet
	return stored == null ? false : stored == "true";
}
export function SetCapturePreSessionLogs(value: boolean) {
	localStorage.setItem(capturePreSessionLogs_StorageKey, String(value));
}

// if "capture pre-session logs" is disabled, defer installing the console-intercepts until the first session starts
// (so that console.log/etc. before that point are not captured into the sessionless-log-period)
if (GetCapturePreSessionLogs()) {
	InstallConsoleIntercepts();
} else {
	OnFirstSessionStart(()=>InstallConsoleIntercepts());
}

function InstallConsoleIntercepts() {
	for (const funcName of ["log", "info", "warn", "error"]) {
		Intercept(funcName);
	}
}
function Intercept(funcName: string) {
	var original = console[funcName];
	console[funcName] = function(...args) {
		const hasBeenSessionLogged = args.length == 1 && IsString(args[0]) && args[0].startsWith("[SessionLog] ");
		if (!hasBeenSessionLogged) {
			const messageStr = args.map(arg=>{
				if (IsString(arg)) return arg.toString();

				// special exemptions (things that, if we try serializing, would cause slowdown/issues)
				// NOTE: It might seem like it'd be better to put these checks within the ToJSON_Advanced func's entryReplacer_pre func, but that is too late (threejs puts toJson() funcs on its objects, which run before our filtering)
				if (arg instanceof THREE.Object3D) return "[threejs-obj; omitted]";
				//if (value instanceof THREE.Mesh) return "[threejs-mesh; omitted]";

				return ToJSON_Advanced(arg, {catchErrors: true});
			}).join(" ");
			SessionLog(messageStr, funcName == "error" ? LogType.App_Error : LogType.App_Log, {alsoLogToConsole: false});
		}

		// block error-logging for a specific case: in android app, with proxy-to-dev-server enabled (which causes rspack's dev-server client to try to connect, but to the wrong URL below, causing non-disableable errors)
		// commented; this doesn't work because the error is not logged through console.error
		/*if (funcName == "error" && args[1]?.target?.constructor?.name == "WebSocket" && args[1].target.url == "wss://lucidfrontier.com:4101/ws") {
			return; // block this error from being logged
		}*/

		return original.apply(this, args);
	};
}

/** Call this function instead of console.log, for cases where you need to bypass the various monkey-patches/wrappers for console.log.
 * Example: For log entries passing a large object (to inspect in console), but that also need to be garbage-collected. (without direct path, sentry's monkey-patch holds a references to the passed object, for its "breadcrumbs" thing) */
// EDIT: Does this even help? Because console.log appears to still "hold onto" the object for the purpose of displaying in-console anyway...
export const Log_Direct: typeof console.log = (...args: any[])=>{
	return console["log_orig"].apply(console, args); // eslint-disable-line prefer-spread
};